<template lang="pug">
  div
    SingleNumWrapper(
      :chartType="'httpFailedRateNum'"
      :chartTitle="$t('dashboard.httpFailedRate')"
      :numeralFormat="'0.00%'"
      :maxFontSize="'42px'"
      :withCard="withCard"
    )
    BarChartWrapper(
      :chartType="'httpStatusBarChart'"
      :chartTitle="''"
      :withCard="withCard"
      :chartWidth="600"
      :chartHeight="100"
      :xAxesDisplay="true"
      :yAxesDisplay="false"
      :legendDisplay="false"
      :barBorderColors="[colorScheme.blue.border]"
      :barBackgroundColors="[colorScheme.blue.fill]"
      :withPropRawBtn="false"
      )
</template>
<script>
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import colorScheme from "@/data/colorScheme";

export default {
    components: {
        SingleNumWrapper,
        BarChartWrapper
    },
    props: {
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        withCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            colorScheme: colorScheme
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage/MonitoringCard.vue